<template>
  <div class="space-y-6">
    <!-- 广告标题 -->
    <div class="flex items-center justify-between">
      <div class="flex items-center space-x-3 flex-1">
        <div class="flex items-center space-x-2 bg-purple-50 px-3 py-1.5 rounded-lg border border-purple-200">
          <span class="text-sm text-purple-700">广告名称</span>
        </div>
        <el-input
          v-model="localName"
          placeholder="请输入广告名称"
          size="small"
          class="max-w-xs"
          @input="handleNameChange"
        />
      </div>
      <div class="flex items-center space-x-4">
        <div class="flex items-center space-x-2">
          <span class="text-xs text-gray-500">状态</span>
          <el-switch
            v-model="localStatus"
            active-color="#8b5cf6"
            inactive-color="#d1d5db"
            @change="handleStatusChange"
          />
        </div>
        <el-button
          type="text"
          size="mini"
          class="text-red-500 hover:text-red-700"
          :disabled="!canDelete"
          @click="handleDelete"
        >
          <i class="el-icon-delete"></i> 删除
        </el-button>
        <span class="text-xs text-gray-400">出价 $6.5</span>
      </div>
    </div>

    <!-- 受众定位 -->
    <div class="bg-white rounded-lg border border-gray-100 p-4">
      <div class="flex items-center space-x-2 mb-4">
        <svg class="w-4 h-4 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
        </svg>
        <span class="text-sm font-medium text-gray-700">受众定位</span>
      </div>
      <div class="grid grid-cols-2 gap-6">
        <div class="space-y-3">
          <div>
            <div class="text-xs text-gray-500 mb-1">地理位置(地区/城市)</div>
            <div class="text-sm text-gray-800">{{ getLocations() }}</div>
          </div>
          <div>
            <div class="text-xs text-gray-500 mb-1">广告系列出价 CPA</div>
            <div class="flex items-center space-x-2">
              <input type="checkbox" class="w-4 h-4 text-purple-600 rounded" checked disabled />
              <span class="text-sm text-gray-700">使用广告系列出价设置</span>
            </div>
          </div>
          <div class="text-xs text-gray-500">$ 6.5</div>
        </div>
        <div class="space-y-3">
          <div>
            <div class="text-xs text-gray-500 mb-1">优化定位</div>
            <div class="text-sm text-gray-700">可以定位</div>
          </div>
          <div>
            <div class="text-sm text-gray-700">
              <span class="text-red-500">▶</span> YouTube 短视频广告、YouTube 信息流
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 text-xs text-gray-500">兴趣</div>
    </div>

    <!-- 广告素材 -->
    <div class="bg-white rounded-lg border border-gray-100 p-4">
      <div class="flex items-center space-x-2 mb-4">
        <svg class="w-4 h-4 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
        </svg>
        <span class="text-sm font-medium text-gray-700">广告素材</span>
        <span class="text-xs text-gray-400">(1 items)</span>
      </div>
      <div class="border border-purple-200 rounded-lg p-4 bg-purple-50/30">
        <div class="flex items-center space-x-2 mb-3">
          <span class="text-xs px-2 py-0.5 bg-purple-100 text-purple-700 rounded">广告1</span>
          <span class="text-xs text-gray-500">{{ data.name || '未命名广告' }}</span>
        </div>
        <div class="flex space-x-3 mb-4">
          <div class="w-16 h-16 rounded-lg bg-yellow-200 flex items-center justify-center">
            <svg class="w-6 h-6 text-yellow-600/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
          </div>
          <div class="w-16 h-16 rounded-lg bg-green-200 flex items-center justify-center">
            <svg class="w-6 h-6 text-green-600/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
          </div>
          <div class="w-16 h-16 rounded-lg bg-pink-200 flex items-center justify-center">
            <svg class="w-6 h-6 text-pink-600/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
          </div>
          <div class="w-16 h-16 rounded-lg bg-purple-200 flex items-center justify-center">
            <svg class="w-6 h-6 text-purple-600/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
          </div>
        </div>
        <div class="space-y-1">
          <div class="text-xs text-gray-500">目标网址</div>
          <div class="text-xs text-blue-600 truncate">{{ data.finalUrl || 'https://example.com/...' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdDetail',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    adGroupData: {
      type: Object,
      default: () => ({})
    },
    currency: {
      type: String,
      default: 'USD'
    },
    canDelete: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      localName: '',
      localStatus: true
    }
  },
  watch: {
    'data.name': {
      handler(val) {
        this.localName = val || ''
      },
      immediate: true
    },
    'data.status': {
      handler(val) {
        this.localStatus = val === 'ENABLED'
      },
      immediate: true
    }
  },
  methods: {
    getLocations() {
      if (!this.adGroupData.locations || this.adGroupData.locations.length === 0) return '可以定位'
      return this.adGroupData.locations.map(l => l.name || l).join(', ')
    },
    handleNameChange(value) {
      this.$emit('update:name', value)
    },
    handleStatusChange(value) {
      this.$emit('update:status', value ? 'ENABLED' : 'PAUSED')
    },
    handleDelete() {
      this.$emit('delete')
    }
  }
}
</script>

<style scoped>
.max-w-xs {
  max-width: 200px;
}
</style>
